import { Box, Typography } from "@mui/material";
import React from "react";
import { theme } from "../../Assets/Theme/theme";

function TextArea({ label, value, onChange, rows = 10, placeholder }) {
  return (
    <Box sx={{ width: "100%" }}>
      {label && (
        <Typography
          variant="body1"
          sx={{
            fontWeight: 700,
            mb: 1,
            color: theme.colors.text || "#333",
            fontSize: "20px"
          }}
        >
          {label}
        </Typography>
      )}
      <textarea
        value={value}
        onChange={onChange}
        rows={rows}
        placeholder={placeholder}
        style={{
          width: "100%",
          padding: "12px",
          borderRadius: "8px",
          border: "1px solid #ddd",
          fontSize: "16px",
          lineHeight: "1.5",
          color: "#121212",
          backgroundColor: "#fff",
          resize: "none",
          outline: "none",
        }}
        onFocus={(e) => {
          e.target.style.borderColor = "#ddd";
          e.target.style.boxShadow = "none";
        }}
        onBlur={(e) => {
          e.target.style.borderColor = "#ddd";
          e.target.style.boxShadow = "none";
        }}
      />
    </Box>
  );
}

export default TextArea;
